<header id="headerNavbar" class="position-relative z-3 shadow-sm">
  <nav class="navbar py-2 navbar-expand-lg">
    <div class="container-fluid px-3 px-md-4 d-flex align-items-center position-relative">

      <!-- Brand/Logo -->
      @if (showTitle) {
        <a routerLink="/" class="navbar-brand mb-0 me-3 me-lg-4 text-decoration-none flex-shrink-0">
          <img src="https://www.giocalendario.it/logo.png" class="header-logo img-fluid" alt="Logo GiocaCalendario">
        </a>
      }

      <!-- Navigation Links (Inline on desktop, collapsible on mobile) -->
      <div class="collapse navbar-collapse me-auto" [class.show]="isMenuOpen()" id="navbarContent" #navbarContent (click)="onNavContentClick($event)">
        <div class="navbar-nav gap-1">
          @for (button of navigationButtons; track button.label) {
            @if (!button.showCondition || button.showCondition()) {
              <a [routerLink]="button.routerLink"
                 class="nav-link px-3 py-2 rounded"
                 [routerLinkActive]="'active'">{{ button.label }}</a>
            }
          }
        </div>
      </div>

      <!-- Right side grouped: Menu Toggle + Action Buttons + Theme Toggle -->
      <div class="d-flex align-items-center gap-2 flex-nowrap ms-auto">
        <!-- Main Navigation Toggle Button (visible on mobile) -->
        <button class="btn btn-outline-secondary d-flex align-items-center gap-2 header-menu-toggle-btn d-lg-none"
                type="button"
                (click)="toggleMenu($event)"
                [attr.aria-expanded]="isMenuOpen()"
                aria-controls="navbarContent"
                aria-label="Toggle navigation menu">
          <i class="bi bi-list fs-5"></i>
          <span class="d-none d-sm-inline fw-semibold">Menù</span>
        </button>

        <!-- Action Buttons (Profile / Login) -->
        @for (button of headerButtons; track button.label) {
          @if (!button.showCondition || button.showCondition()) {
            <button class="btn btn-outline-primary btn-sm d-flex align-items-center gap-2 text-nowrap justify-content-start header-action-btn"
                    [routerLink]="button.routerLink"
                    (click)="button.action ? button.action() : null"
                    [attr.id]="button.elementId"
                    [attr.data-bs-toggle]="button.elementId === 'profileBtn' ? 'tooltip' : null"
                    [attr.data-bs-title]="button.elementId === 'profileBtn' ? 'Profilo: ' + getCurrentUserName() : null"
                    [attr.title]="button.elementId === 'profileBtn' ? 'Profilo: ' + getCurrentUserName() : null">
              @if (button.icon) {
                <i [class]="button.icon"></i>
              }
              {{ button.label }}
            </button>
          }
        }

        @if (showThemeToggle) {
          <button (click)="themeService.setTheme(themeService.getTheme() === 'dark' ? 'light' : 'dark')"
                  class="btn btn-outline-secondary d-flex align-items-center justify-content-center rounded p-2 header-theme-btn flex-shrink-0">
            @if (themeService.getTheme() === 'dark') {
              <span>🌞</span>
            } @else {
              <span>🌙</span>
            }
          </button>
        }
      </div>

    </div>
  </nav>
</header>
